import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { IhmChipListComponent } from './ihm-chip-list.component';

@NgModule({
  imports: [CommonModule, MatChipsModule, MatIconModule],
  exports: [IhmChipListComponent],
  declarations: [IhmChipListComponent]
})
export class IhmChipListModule {}
